import { render, staticRenderFns } from "./YourMaxBid.vue?vue&type=template&id=e24497a4&scoped=true&"
import script from "./YourMaxBid.vue?vue&type=script&lang=js&"
export * from "./YourMaxBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24497a4",
  null
  
)

export default component.exports